/*
 * @Description: promotion redux store/reducer/action
 * @Author: Chris
 * @Date: 2021-03-23 15:44:56
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import {
  checkPopUpWindowError,
  EnumPromotionCollapseId,
  EnumPromotionPopWindowType,
  setSwitchTypeState,
  shiftDate,
  shiftingDates,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/common';
import {
  generateDefaultState as _generateDefaultState,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import { msg } from 'src/tools/message';
import { ActionType } from 'src/types/common/common';

// import arrayMove from 'array-move';
// import { msg } from 'src/tools/message';
//import { EnumPromotionSwitch } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/common';

import {
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getHasModified as _getHasModified,
  getLoaded as _getLoaded,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getState as _getState,
  EnumReducers,
  getTranslationState as _getTranslationState,
} from 'src/pages/SalesChannelContentEditor/slice/selectors';

// import { EnumLinkType } from 'src/types/common/linkType';

import { randomNumber } from '@/src/tools/helper';

// import {
//   defaultState as _defaultState,
//   defaultStatus,
// } from 'src/pages/SalesChannelContentEditor/slice';

import { convertDataFromServerToRedux } from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/apiUtil';

import {
  getContentPromotion,
  postContentPromotion,
  postTranslatePromotionPage,
} from '@/src/request/salesChannel/content';
import { IPopUpWindow } from '@/src/types/common/SalesChannel';
import arrayMove from 'array-move';
import moment from 'moment';
import { validateAll } from '../validation';
//import { useSelector } from 'react-redux';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { generateNoneLinkData } from 'src/constrains/LinkLibrary/tools';

export { ActionType, EnumPromotionCollapseId };

export const fetchContentPromotion = createAsyncThunk(
  'fetchSalesChannelContentPromotion',
  async (data: any) => {
    const { uuid, params = {}, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getContentPromotion(uuid, params);
    return { response, isPrimary, isClone };
  },
);

export const submitContentPromotion = createAsyncThunk(
  'submitSalesChannelContentPromotion',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();

    const response = await postContentPromotion(body, params || {});
    return { response, isPrimary };
  },
);

export const translateContentPromotion = createAsyncThunk(
  'translateSalesChannelContentPromotion',
  async ({ uuid, translationEnabled, multiLanguageParams }: any) => {
    const response = await postTranslatePromotionPage(
      uuid,
      translationEnabled,
      multiLanguageParams,
    );
    return { response, translationEnabled };
  },
);

// export function assData(state, data = {}) {
//   console.log(data);
//   Object.keys(data).forEach((i) => {
//     console.log('key', i);
//     if (typeof state[i] === 'object') {
//       state[i] = { ...state[i], ...data[i] };
//     } else {
//       state[i] = data[i];
//     }
//   });
// }

const _defaultContent = {
  featuredProducts: {
    shopCart: { checked: false, title: '' },
    profile: { checked: false, title: '' },
    productSearch: { checked: false, title: '' },
    fourZeroFour: { checked: false, title: '' },
    title: '',
    products: [],
  },
  edm: {
    homePage: {},
    profilePage: {},
    title: '',
    description: '',
    backgroundColor: '',
    textColor: '',
    buttonStyle: {
      text: '提交',
      backgroundColor: '#000000',
      textColor: '#FFFFFF',
    },
    fields: [
      {
        draggableId: randomNumber(),
        category: 'Email',
        required: true,
        type: 'TextField',
        name: 'Your Email Address',
      },
    ],
  },
  popupWindows: {
    editing: {} as IPopUpWindow,
    inUse: [] as IPopUpWindow[],
    previous: [] as IPopUpWindow[],
    pending: [] as IPopUpWindow[],
  },
};

const _collapse = [
  EnumPromotionCollapseId.featuredProducts,
  EnumPromotionCollapseId.edm,
];
const _defaultState = _generateDefaultState(_collapse, _defaultContent);
const defaultState = {
  ..._defaultState,
  ...defaultStatus,
  translationEnabled: false,
  translationLoading: false,
  uuid: null,
  // loaded: false,
  // hasModified: false,
  // collapseOpen: {
  //   [EnumPromotionCollapseId.featuredProducts]: false,
  //   [EnumPromotionCollapseId.edm]: false,
  // },
  // collapseErrorMsgDisplay: {
  //   [EnumPromotionCollapseId.featuredProducts]: {
  //     hasError: false,
  //     display: false,
  //   },
  //   [EnumPromotionCollapseId.edm]: { hasError: false, display: false },
  // },

  // isDataValid: true,
};

const salesChannelContentPromotion = createSlice({
  name: 'salesChannelContentPromotion',
  initialState: defaultState,
  reducers: {
    onProductsChange(state, action) {
      state.hasModified = true;
      const { type, data } = action.payload;

      switch (type) {
        case ActionType.reselect: {
          state.featuredProducts.products = data;
          break;
        }

        case ActionType.delete: {
          state.featuredProducts.products.splice(data, 1);
          break;
        }

        case ActionType.deleteAll: {
          state.featuredProducts.products = data;
          break;
        }

        case ActionType.reorder: {
          const { from, to } = data;
          state.featuredProducts.products = arrayMove(
            state.featuredProducts.products,
            from,
            to,
          );
          break;
        }

        default:
          console.log('promotion reduce default action');
          break;
      }
    },

    onSwitchChange(state, action) {
      state.hasModified = true;
      const { type, data } = action.payload;
      const { switchType } = data;

      switch (type) {
        case ActionType.switchOn: {
          setSwitchTypeState(switchType, state, true);
          break;
        }

        case ActionType.switchOff: {
          setSwitchTypeState(switchType, state, false);
          break;
        }

        default:
          console.log('promotion onSwitchChange reduce default action');
          break;
      }
    },

    onValueChange(state, action) {
      state.hasModified = true;
      const { type, data } = action.payload;

      switch (type) {
        case ActionType.featureProductTitleChange: {
          state.featuredProducts.title = data;
          break;
        }

        case ActionType.edmTitleChange: {
          state.edm.title = data;
          break;
        }

        case ActionType.edmDescriptionChange: {
          state.edm.description = data;
          break;
        }

        case ActionType.edmButtonTextChange: {
          state.edm.buttonStyle = {
            ...state.edm.buttonStyle,
            text: data,
          };
          break;
        }

        default:
          console.log('promotion onValueChange');
          break;
      }
    },

    onStyleChange(state, action) {
      state.hasModified = true;
      const { type, data } = action.payload;

      switch (type) {
        case ActionType.edmBGColor: {
          state.edm.backgroundColor = data;
          break;
        }

        case ActionType.edmTextColor: {
          state.edm.textColor = data;
          break;
        }

        case ActionType.edmButtonBGColor: {
          state.edm.buttonStyle = {
            ...state.edm.buttonStyle,
            backgroundColor: data,
          };
          break;
        }

        case ActionType.edmButtonTextColor: {
          state.edm.buttonStyle = {
            ...state.edm.buttonStyle,
            textColor: data,
          };
          break;
        }

        default:
          console.log('promotion onStyleChange');
          break;
      }
    },

    onEdmFieldsChange(state, action) {
      state.hasModified = true;
      const { type, index, data } = action.payload;

      switch (type) {
        case ActionType.add: {
          state.edm.fields.push(data);
          return;
        }

        case ActionType.delete: {
          state.edm.fields.splice(index, 1);
          return;
        }

        case ActionType.modify: {
          const { name, required } = data;

          if (name && name.length) {
            state.edm.fields[index].name = name;
          }

          if (required !== undefined) {
            state.edm.fields[index].required = required;
          }

          return;
        }

        case ActionType.reorder: {
          const { newIndex, oldIndex } = data || {};
          state.edm.fields = arrayMove(state.edm.fields, oldIndex, newIndex);
          return;
        }

        default:
          console.log('onEdmFieldsChange default');
          return;
      }
    },

    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload;
      _onCollapseOpen(state, idArr);
    },

    onSettingPopUpDate(state, action) {
      state.hasModified = true;
      const { id, date } = action.payload;
      updatePopUpState(state, id, 'beginDate', date.beginDate);
      updatePopUpState(state, id, 'beginTime', date.beginTime);
      updatePopUpState(state, id, 'endDate', date.endDate);
      updatePopUpState(state, id, 'endTime', date.endTime);
    },

    onSettingPopUpRemark(state, action) {
      state.hasModified = true;
      const { id, remark } = action.payload;
      updatePopUpState(state, id, 'remark', remark);
    },

    onSettingPopUpType(state, action) {
      state.hasModified = true;
      const { id, promotionType } = action.payload;
      updatePopUpState(state, id, 'promotionType', promotionType);
    },

    onSettingPopUpImage(state, action) {
      state.hasModified = true;
      const { id, image } = action.payload;
      updatePopUpState(state, id, 'image', image);
    },
    // onCloseAllCollapse(state) {
    //   Object.keys(state.collapseOpen).forEach((i) => {
    //     state.collapseOpen[i] = false;
    //   });
    // },

    onSettingPopUpLink(state, action) {
      state.hasModified = true;
      const { id, linkTo } = action.payload;
      updatePopUpState(state, id, 'linkTo', linkTo);
    },

    onSettingPopUpFrequency(state, action) {
      state.hasModified = true;
      const { id, displayFrequency } = action.payload;
      const keys = Object.keys(state.popupWindows) || [];
      keys.forEach((key) => {
        const value = state.popupWindows[key];
        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (item.id === id) {
              const old = value['displayFrequency'];
              item['displayFrequency'] = {
                ...old,
                ...displayFrequency,
              };
            }
          });
        } else {
          if (value.id === id) {
            const old = value['displayFrequency'];
            value['displayFrequency'] = {
              ...old,
              ...displayFrequency,
            };
          }
        }
      });
    },

    onAddNewCollapseItem(state, action) {
      state.hasModified = true;
      const { id } = action.payload;
      state.collapseOpen[id] = true;

      state.collapseErrorMsgDisplay[id] = {
        hasError: false,
        display: false,
      };
      state.popupWindows.editing = {
        id,
        linkTo: generateNoneLinkData(),
        promotionType: EnumPromotionPopWindowType.ImageAndLink,
        displayFrequency: {
          basedOn: 'Visit',
          frequency: 2,
        },
        remark: `Popup window promotion ${_getMaxPopUpID(state.popupWindows)}`,
      };
    },

    onShiftEditingItem(state, action) {
      state.hasModified = true;
      const isValid = checkPopUpWindowError(state.popupWindows.editing); //检查方法不对
      if (isValid) {
        const dateList = {
          inUse: state.popupWindows.inUse,
          previous: state.popupWindows.previous,
          pending: state.popupWindows.pending,
        };
        shiftDate(moment(), state.popupWindows.editing, dateList);
      } else {
        const item = { ...state.popupWindows.editing };
        state.popupWindows.pending.unshift(item);
        state.popupWindows.editing = {} as IPopUpWindow;
      }
    },

    onShiftItems(state, action) {
      if (!state.translationEnabled) state.hasModified = true;
      const dateList = shiftingDates(state.popupWindows);
      state.popupWindows.editing = dateList.editing;
      state.popupWindows.inUse = dateList.inUse;
      state.popupWindows.pending = dateList.pending;
      state.popupWindows.previous = dateList.previous;
    },

    onDeletePopUpWindow(state, action) {
      state.hasModified = true;
      const { id: _id } = action.payload;
      const popupWindows = state.popupWindows;

      const keys = Object.keys(popupWindows) || [];
      keys.forEach((key) => {
        const value = popupWindows[key];
        if (Array.isArray(value)) {
          const index = value.findIndex((item) => item.id === _id);
          if (index > -1) {
            value.splice(index, 1);
          }
        } else {
          if (_id === value.id) {
            popupWindows[key] = {};
          }
        }
      });
    },

    onDuplicatePopUpWindow(state, action) {
      state.hasModified = true;
      const { id: _id } = action.payload;
      const popupWindows = state.popupWindows;

      let target = null;
      const keys = Object.keys(popupWindows) || [];
      keys.forEach((key) => {
        const value = popupWindows[key];
        if (Array.isArray(value)) {
          const index = value.findIndex((item) => item.id === _id);
          if (index > -1) {
            target = value[index];
          }
        } else {
          if (_id === value.id) {
            target = value;
          }
        }
      });

      if (target) {
        const newId = randomNumber();
        state.popupWindows.pending.unshift({
          ...target,
          id: newId,
          beginDate: '',
          beginTime: '',
          endDate: '',
          endTime: '',
          remark: `Popup window promotion ${_getMaxPopUpID(
            state.popupWindows,
          )}`,
          uuid: null,
        });
        state.collapseOpen[newId] = false;
      }
    },

    validation(state, action) {
      const { isPrimary } = action.payload;
      const { popupWindows } = state;
      const hasError = validateAll(popupWindows, isPrimary);
      state.isDataValid = !hasError;
    },

    resetData(state) {
      assData(state, defaultState);
    },

    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchContentPromotion.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(fetchContentPromotion.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(fetchContentPromotion.fulfilled, (state, action) => {
      const { response, isClone } = action.payload;

      const _data = convertDataFromServerToRedux(response) || {};

      assData(state, _data);
      if (isClone) state.hasModified = true;
    });
    builder.addCase(submitContentPromotion.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(submitContentPromotion.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(submitContentPromotion.fulfilled, (state, action) => {
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      state.hasModified = false;
      const { response } = action.payload;
      const _data = convertDataFromServerToRedux(response) || {};
      assData(state, _data);
    });
    // builder.addCase(validation.fulfilled, (state, action) => {
    //   const { isPrimary } = action.payload;
    //   const { popupWindows } = state;
    //   const hasError = validateAll(popupWindows, isPrimary);
    //   state.isDataValid = !hasError;
    // });
    builder
      .addCase(translateContentPromotion.pending, (state) => {
        state.translationLoading = true;
      })
      .addCase(translateContentPromotion.fulfilled, (state, action) => {
        state.translationLoading = false;
        const { response, translationEnabled } = action.payload;
        if (response) {
          state.translationEnabled = translationEnabled;
        }
      })
      .addCase(translateContentPromotion.rejected, (state) => {
        state.translationLoading = false;
      });
  },
});

export const getLoaded = () => {
  return _getLoaded(EnumReducers.promotion);
};

export const getPopUpWindowData = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.promotion.popupWindows,
    (popupWindows) => {
      return popupWindows;
    },
  );
};

export const getOccupiedRanges = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.promotion.popupWindows,
    (state: Record<string, any>) =>
      state.salesChannelContent.promotion.collapseOpen,
    (popupWindows, collapseOpen) => {
      let id = '';
      for (const [k, v] of Object.entries(collapseOpen)) {
        if (v) {
          id = k;
        }
      }
      const { editing, inUse = [], previous = [], pending = [] } = popupWindows;

      const list = [editing, ...inUse, ...previous, ...pending]
        .filter((v) => v && v.id !== id)
        .map((v: IPopUpWindow) => ({
          beginDate: v.beginDate,
          beginTime: v.beginTime,
          endDate: v.endDate,
          endTime: v.endTime,
        }));

      return list;
    },
  );
};

const _getMaxPopUpID = (popupWindows) => {
  let max = 1;
  const keys = Object.keys(popupWindows) || [];
  keys.forEach((key) => {
    const value = popupWindows[key];
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item.remark && item.remark.length) {
          ++max;
        }
      });
    } else {
      if (value.remark && value.remark.length) {
        ++max;
      }
    }
  });
  return max;
};

const updatePopUpState = (state, id, propertyName, promotionValue) => {
  const keys = Object.keys(state.popupWindows) || [];
  keys.forEach((key) => {
    const value = state.popupWindows[key];
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item.id === id) {
          item[propertyName] = promotionValue;
        }
      });
    } else {
      if (value.id === id) {
        value[propertyName] = promotionValue;
      }
    }
  });
};

export const getMaxPopUpID = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.promotion.popupWindows,
    (popupWindows) => {
      return _getMaxPopUpID(popupWindows);
    },
  );
};

export const checkDuplicatedName = (name: string, id: string) => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.promotion.popupWindows,
    (popupWindows) => {
      let duplicated = false;
      const keys = Object.keys(popupWindows) || [];
      keys.forEach((key) => {
        const value = popupWindows[key];
        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (
              Boolean(item.remark) &&
              Boolean(item.id) &&
              item.remark === name &&
              item.id !== id
            ) {
              duplicated = true;
            }
          });
        } else {
          if (
            Boolean(value.remark) &&
            Boolean(value.id) &&
            value.remark === name &&
            value.id !== id
          ) {
            duplicated = true;
          }
        }
      });
      return duplicated;
    },
  );
};

export const getCollapseOpenId = () => {
  return createSelector(
    (state: any) => {
      let id = '';
      const data = state.salesChannelContent.promotion.collapseOpen;
      for (const [k, v] of Object.entries(data)) {
        if (v) {
          id = k;
        }
      }
      return id;
    },
    (v) => {
      return v;
    },
  );
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.promotion, id);
};

export const getWholeCollapseOpen = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.promotion.collapseOpen,
    (v) => v,
  );
};

export const getFeatureProduct = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.promotion.featuredProducts,
    (v) => v,
  );
};

export const getPopUpWindowDataById = (id: string) => {
  return createSelector(
    (state: any) => {
      const { editing, inUse, previous, pending } =
        state.salesChannelContent.promotion.popupWindows;
      const list = [...inUse, ...previous, ...pending, editing];
      const item = list.find((v) => v.id === id);
      return item ? item : {};
    },
    (v) => v,
  );
};

export const getContent = (id) => {
  return createSelector(
    (state: any) => state.salesChannelContent.promotion.collapseOpen[id],
    (open) => {
      return open;
    },
  );
};

export const getState = () => {
  return _getState(EnumReducers.promotion);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.promotion, id);
};

export const getHasModified = () => {
  const hasModified = _getHasModified(EnumReducers.promotion);
  return hasModified;
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.promotion);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.promotion);
};

export const getTranslationState = () => {
  return _getTranslationState(EnumReducers.promotion);
};

export const {
  onAddNewCollapseItem,
  onSwitchChange,
  onProductsChange,
  onValueChange,
  onStyleChange,
  onEdmFieldsChange,
  onSettingPopUpDate,
  onSettingPopUpRemark,
  onSettingPopUpType,
  onSettingPopUpImage,
  onSettingPopUpLink,
  onSettingPopUpFrequency,
  onShiftEditingItem,
  onShiftItems,
  onDeletePopUpWindow,
  onDuplicatePopUpWindow,
  onCollapseOpen,
  onErrorChange,
  validation,
  resetData,
  // onCloseAllCollapse,
} = salesChannelContentPromotion.actions;

export default salesChannelContentPromotion.reducer;
